import React from 'react';
import PropTypes from 'prop-types';
import { sanitize as sanitizeHtml } from 'dompurify';
import Modal from '../CommonComponents/AdvModal';
import { PrimaryButton } from '../CommonComponents/Button';
import getImagePath from '../CommonUtils/getImagePath';

const { ADV } = window;

class TermsView extends React.Component {
  componentDidMount() {
    const { fetchTerms, clientId, areTermsAccepted } = this.props;

    if (!areTermsAccepted) {
      fetchTerms(clientId);
    }
  }

  render() {
    const {
      termsRawText,
      isAcceptingTerms,
      isFetchingTerms,
      areTermsAccepted,
      clientId,
      onAcceptTerms,
      whitelabelLogo,
      forDataAggregation,
    } = this.props;

    let termsPdfDownloadUrl;
    let termsCopy;

    if (forDataAggregation) {
      termsCopy = termsRawText.dataAggregationTCs;
      termsPdfDownloadUrl = `${ADV.settings.endpoints.assets}policies/data-aggregation-terms.pdf`;
    } else {
      termsCopy = termsRawText[clientId ? 'clientTCs' : 'advisorTCs'];
      termsPdfDownloadUrl = `${ADV.settings.endpoints.assets}policies/${
        clientId ? 'client' : 'advisor'
      }-terms.pdf`;
    }

    return (
      <Modal
        isOpen={!areTermsAccepted}
        className="terms-modal"
        overlayClassName="terms-modal-overlay"
        bodyClass="terms"
        htmlClass="terms"
      >
        <div className="terms-header">
          <h2 className="terms-title">
            Terms
            {clientId ? ' of Service' : ' and Conditions'}
          </h2>
          <img
            className="terms-logo"
            src={getImagePath(whitelabelLogo || 'logo-hires-color.png', Boolean(whitelabelLogo))}
            alt="Orion Planning Logo"
          />
        </div>

        <div className="terms-body">
          {isFetchingTerms ? (
            <i className="far fa-circle-notch fa-spin fa-3x fa-fw terms-spinner" />
          ) : (
            <div className="terms-text terms-scrollbar">
              <div
                dangerouslySetInnerHTML={{
                  __html: sanitizeHtml(termsCopy),
                }}
              />
            </div>
          )}
        </div>

        <div className="terms-footer">
          {clientId ? (
            <div />
          ) : (
            <a
              href={termsPdfDownloadUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="terms-download"
            >
              <i className="terms-download-icon fa fa-download" />
              <span className="terms-download-text">Download</span>
            </a>
          )}

          <PrimaryButton
            disabled={isAcceptingTerms || isFetchingTerms}
            isLoading={isAcceptingTerms}
            onClick={onAcceptTerms}
          >
            Accept
          </PrimaryButton>
        </div>
      </Modal>
    );
  }
}

TermsView.defaultProps = {
  clientId: null,
  whitelabelLogo: '',
  forDataAggregation: false,
};

TermsView.propTypes = {
  termsRawText: PropTypes.shape({
    clientTCs: PropTypes.string,
    advisorTCs: PropTypes.string,
    dataAggregationTCs: PropTypes.string,
  }).isRequired,
  isAcceptingTerms: PropTypes.bool.isRequired,
  isFetchingTerms: PropTypes.bool.isRequired,
  areTermsAccepted: PropTypes.bool.isRequired,
  clientId: PropTypes.number,
  fetchTerms: PropTypes.func.isRequired,
  onAcceptTerms: PropTypes.func.isRequired,
  whitelabelLogo: PropTypes.string,
  forDataAggregation: PropTypes.bool,
};

export default TermsView;
